import { EN_DASH, getFieldValue } from "@digitallab/grid-common-frontend-components";
import BooleanIntRender from "./BooleanIntRender";

/**
 * The columns stored as 0/1 rather than true/false, which read as Yes/No.
 *
 * Both spellings are listed because the column id is snake_case in the grid and camelCase in the
 * schema, and this renderer is keyed off whichever one the column carries. booking-frontend shows
 * the same two fields the same way.
 */
const INT_BOOLEAN_COLUMN_IDS = ["is_hazardous", "isHazardous", "should_assisted", "shouldAssisted"];

/**
 * Renders any boolean column, keyed off the column being rendered rather than a hard-coded pair.
 *
 * `getColumnObj` attaches this to every key in `listOfBooleanRequired()`, which is now derived from
 * the schema (`renderSlot === BOOLEAN`) rather than hand-written. The hand-written list held only
 * `isBookable` and `isVisualized` — the two this used to name — so naming them worked; the derived
 * list also carries `checkInRequired`, `isHazardous` and `shouldAssisted`, which fell through to a
 * literal "false" on every row. `checkInRequired` is a column logbook already showed.
 *
 * A missing value renders as a dash rather than as "No". `is_hazardous` and `should_assisted` are
 * stripped from the CloudSearch field list in `EquipmentMainPage.requestServer`, so on that engine
 * they arrive empty for every row — reporting that as a definite "No" would be wrong.
 *
 * `getFieldValue` resolves both search shapes — CloudSearch returns each field as an array,
 * OpenSearch as a scalar.
 */
const BooleanRender = (params) => {
  const columnId = params?.column?.colId;
  const fieldValue = getFieldValue(params?.data, columnId);

  // "null" is the string the index returns for an empty field, and it is truthy —
  // BooleanIntRender would read it as NaN and answer "No".
  if (
    fieldValue === undefined ||
    fieldValue === null ||
    fieldValue === "" ||
    fieldValue === "null"
  ) {
    return <div>{EN_DASH}</div>;
  }

  if (INT_BOOLEAN_COLUMN_IDS.includes(columnId)) {
    return <div>{BooleanIntRender(fieldValue)}</div>;
  }

  return <div>{String(fieldValue)}</div>;
};

export default BooleanRender;
